"use strict";

define(['app', 'jquery'], function (app, $) {
  return app.Marionette.ItemView.extend({
    template: false,
    vars: {
      now: new Date().getTime(),
      day: 24 * 60 * 60 * 1000
    },
    ui: {
      links: 'a',
      modal: '#modal__survey'
    },
    events: {
      'click @ui.a': 'onShowSurvey'
    },
    options: {
      url: false,
      cookieName: '_survey',
      cookieLifeTimeInDays: 30,
      randomFactor: false,
      minSecondsBeforeDisplay: false,
      displayOnExitAlso: false
    },
    components: {
      modal: function modal() {
        var self = this;
        return {
          name: 'modal',
          el: '@ui.modal',
          data: {
            modal_id: 'modal_survey',
            mainClass: 'modal--survey',
            showCloseBtn: true,
            closeOnBgClick: false,
            enableEscapeKey: false,
            type: 'iframe',
            src: self.getOption('url')
          }
        };
      }
    },
    getStorageItem: function getStorageItem(itemName) {
      var item = window.localStorage.getItem(itemName);
      return item ? JSON.parse(item) : null;
    },
    setStorageItem: function setStorageItem(itemName, item) {
      window.localStorage.setItem(itemName, JSON.stringify(item));
    },
    getStorageItemProp: function getStorageItemProp(itemName, propName) {
      var item = this.getStorageItem(itemName);
      return item && item[propName] ? item[propName] : null;
    },
    setStorageItemProp: function setStorageItemProp(itemName, itemProp, itemValue) {
      var item = this.getStorageItem(itemName) || {};
      item[itemProp] = itemValue;
      window.localStorage.setItem(itemName, JSON.stringify(item));
    },
    getStartTime: function getStartTime() {
      var tstart = this.getStorageItemProp('survey', 'tstart');

      if (!tstart) {
        this.setStorageItemProp('survey', 'tstart', this.vars.now);
        tstart = this.getStorageItemProp('survey', 'tstart');
      }

      return Number(tstart);
    },
    startTimer: function startTimer(timeout) {
      var self = this;
      var tstart = this.getStartTime();
      timeout = Number(timeout) * 1000 - (this.vars.now - tstart);
      window.setTimeout(function () {
        self.setStorageItemProp('survey', 'tstart', null);
        self.showSurvey();
      }, timeout);
    },
    // will block survey from appearing for set number of days
    block: function block(nrOfDays) {
      this.setStorageItemProp('survey', 'tlife', this.vars.now + nrOfDays * this.vars.day);
    },
    isBlocked: function isBlocked() {
      var tlife = this.getStorageItemProp('survey', 'tlife');
      return tlife && Number(tlife) > this.vars.now;
    },
    onShowSurvey: function onShowSurvey(e) {
      if (!this.isBlocked()) {
        if (!e) e = window.event;
        e.preventDefault();
        e.stopPropagation();
        this.showSurvey();
      }
    },
    showSurvey: function showSurvey() {
      if (this.isBlocked()) {
        return false;
      }

      this.block(this.getOption('cookieLifeTimeInDays'));
      app.events.commands.execute('modal:modal_survey:show', {
        type: 'iframe',
        items: {
          src: this.getOption('url')
        }
      });
    },
    getMultiplier: function getMultiplier(random) {
      var _length = String(random).length;
      var _num = '1';
      var k;

      for (k = 0; k < _length; k++) {
        _num += '0';
      }

      return parseInt(_num);
    },
    // when user hovers over address bar/ tabs area, assume user is planning to navigate away:
    bindWindowLeave: function bindWindowLeave() {
      var self = this;
      document.body.addEventListener('mouseleave', function (e) {
        var top = e.pageY;

        if (top < 10) {
          self.triggerMethod('show:survey', e);
        }
      });
    },
    validateRandomFactor: function validateRandomFactor(random) {
      return !random || parseInt(Math.random() * this.getMultiplier(random)) % random === 0;
    },
    onRender: function onRender() {
      var isSelectedUser = this.validateRandomFactor(this.getOption('randomFactor'));
      var self = this;

      if (this.getOption('url') && !this.isBlocked() && isSelectedUser) {
        // 1) display survey after click on external link:
        $(document).on('click touchstart', "a[href*='http']:not([href*='" + window.location.hostname + "']):not(.attachment__link):not(.fancybox)", function (e) {
          self.triggerMethod('show:survey', e);
        }); // 2) display survey after timer completes

        var timeout = this.getOption('minSecondsBeforeDisplay');

        if (timeout) {
          this.startTimer(timeout);
        } // 3) default: display survey on user exit


        if (!timeout || this.getOption('displayOnExitAlso')) {
          this.bindWindowLeave();
        }
      }
    }
  });
});